import hostedLoader from '../../assets/images/hosted/loader.gif';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  globalPayin: {
    loader: hostedLoader
  }
};